// @ts-nocheck
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import styled from "styled-components";
import MainCard from "./Card";
import {
  faCalendar,
  faFile,
  faList,
 
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import Hearder from "./Header";
import { isMobile } from "react-device-detect";

function Dashboard() {
  return (
    <>
      <Hearder Origin={"Admin dashboard"} />
      <div className="main-container">
        

        <CardsContainer isMobile={isMobile}>
          <MainCard
            icon={faUserCog}
            cardHeading={"Book New"}
            variant={"warning"}
            link="/admin-booking"
          />
       
          <MainCard
            icon={faCalendar}
            cardHeading={"Disable Days"}
            variant={"danger"}
            link="/disable-dates"
          />{" "}
          <MainCard
            icon={faFile}
            cardHeading={"Logs"}
            variant={"primary"}
            link="/logs"
          />
          <MainCard
            icon={faList}
            cardHeading={" Appointments"}
            variant={"dark"}
            link="/appointments"
          />
        </CardsContainer>
      </div>
    </>
  );
}

const CardsContainer = styled.div`
  width: 100%;
  height: 90%;
  background-color: #f2f7f8;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  gap: ${(props: any) => (props.isMobile ? "10px" : "50px")};
`;
export default Dashboard;
